import { Component, OnInit } from '@angular/core';
import { User } from 'src/app/model/user.model';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/services/user/user.service';
import { NgForm, FormsModule } from '@angular/forms';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-edituser',
  templateUrl: './edituser.component.html',
  styleUrls: ['./edituser.component.css']
})
export class EdituserComponent implements OnInit {

  
  idno: string;
  userData: any;
  user: User;

  constructor(private router: Router, private route: ActivatedRoute,
    private userServices: UserService) {
    this.idno = this.route.snapshot.params.userid;
  }

  ngOnInit() {
    this.getUserById();
  }

  getUserById() {
    this.userServices.EditSiteUser(this.idno).subscribe(
      (data) => {
        this.userData = data;
        this.user = this.userData;
        console.log(this.userData);
      }
    )
  }

  editSiteUserForm(form: NgForm) {
    form.value.id = this.idno;
    console.log(form.value);
    if (!isNullOrUndefined(form.value.userType)) {
      if (form.value.userType == 1) {
        form.value.type = "Admin";
        form.value.registerCode = "mpadmin";
      }
      else if (form.value.userType == 2) {
        form.value.type = "Employee";
        form.value.registerCode = "mpemployee";
      }
      else if (form.value.userType == 3) {
        form.value.type = "HR";
        form.value.registerCode = "mphr";
      }
      else{}
    }
    this.userServices.editSiteUserProfile(form.value).subscribe(
      (data: any) => {
        if (data == true) {
          alert("user updated");
          this.router.navigate(['/profile']);
        }
        else {
          alert("An error occured.");
        }
      }
    )
  }

}
